<div mat-dialog-title>
  <div class="row">
    <div class="col-sm-10">
      <mat-label class="dialog-title">{{ 'DIALOGS.EDIT_BREAK_IN_OUT_TITLE' | translate }}</mat-label>
    </div>
    <div class="col-sm-2 right-aligned">
      <mat-icon (click)="onCancel()">close</mat-icon>
    </div>
  </div>
</div>
<mat-dialog-content>
  <form class="edit-break-in-out-form" [formGroup]="editForm">
    <div class="horizontal-form-field">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'COLUMNS.BREAK_IN_OUT.JUSTIFICATION' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="justification"
          [attr.maxlength]="maxJustificationLength"
        ></textarea>
      </mat-form-field>
      <div class="char-count" [class.char-count--over]="(editForm.get('justification')?.value?.length || 0) > maxJustificationLength">
        {{ editForm.get('justification')?.value?.length || 0 }} / {{ maxJustificationLength }}
      </div>
    </div>

    <div class="horizontal-form-field">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'COLUMNS.BREAK_IN_OUT.STATUS_COMMENT' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="statusComment"
          [attr.maxlength]="maxStatusCommentLength"
        ></textarea>
      </mat-form-field>
      <div class="char-count" [class.char-count--over]="(editForm.get('statusComment')?.value?.length || 0) > maxStatusCommentLength">
        {{ editForm.get('statusComment')?.value?.length || 0 }} / {{ maxStatusCommentLength }}
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="submit" (click)="onSave()" [disabled]="!hasChanges || isSaving">
    {{ 'COMMON.BUTTONS.SAVE' | translate }}
  </button>
  <button mat-button class="discard-changes" (click)="onCancel()">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
